<template lang="html">
	<div :key="feature.slug" class="omapi-feature">
		<common-selectable-input
			type="checkbox"
			:checked="shouldBeChecked"
			name="extraFeatures"
			:value="feature.slug"
			:disabled="feature.free"
			:input-class="feature.free ? 'omapi-checkbox__input-green' : ''"
			@input="setValue"
		>
			<template #description>
				<div class="omapi-feature__description">
					<h3>{{ getFeatureProp(feature.slug, 'title') }}</h3>
					<div>{{ getFeatureProp(feature.slug, 'description') }}</div>
				</div>
			</template>
		</common-selectable-input>
	</div>
</template>

<script lang="js">
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters } = createNamespacedHelpers('wizard')

export default {
	props : {
		feature : {
			type     : Object,
			required : true,
		},
		isChecked : {
			type    : Boolean,
			default : () => null,
		},
	},
	computed : {
		...mapState([ 'extraFeatures' ]),
		...mapGetters([ 'inExtraFeatures', 'getFeatureProp' ]),
		shouldBeChecked () {
			if (null !== this.isChecked) {
				return this.isChecked
			}
			return this.feature.free || this.inExtraFeatures(this.feature.slug)
		},
	},
	methods : {
		setValue (evt) {
			this.$store.commit('wizard/extraFeatures', evt.target.value)
		},
	},
};
</script>
